import { 
    configureStore, 
    combineReducers 
} from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";
import authReducer from "../stores/authSlice";

import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const reducers = combineReducers({
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer
});

const persistConfig = {
    key: "root",
    version: 1,
    storage,
    blacklist: [apiSlice.reducerPath],
};

// remove logout for persisted state!
const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            },
        }).concat(apiSlice.middleware),

    devTools: process.env.NODE_ENV === "development"
});